<form #mapForm="ngForm" autocomplete="off" [formGroup]="confirmationControl">

  <mat-form-field  class="fullWidth">
    <mat-label>Identifier name</mat-label>
    <input matInput [(ngModel)]="data.description" name="identifier" maxlength="255" formControlName="identifier">
  </mat-form-field>

  <mat-form-field  class="fullWidth">
    <mat-label>User name</mat-label>
    <input matInput required [(ngModel)]="data.userName" name="user-name" maxlength="255"
           formControlName="userName" autocomplete="new-password">
    <mat-error>
      Username is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Password</mat-label>
    <input type="password" formControlName="password" matInput [(ngModel)]="data.password" name="password" required autocomplete="new-password">
    <mat-error>Invalid password</mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Confirm password</mat-label>
    <input type="password" formControlName="confirm-password" required matInput [(ngModel)]="data.passwordConfirm"
           name="confirm-password" autocomplete="new-password"
           [errorStateMatcher]="matcher">
    <mat-error *ngIf="confirmationControl.errors?.mismatch">Confirm password does not match Password</mat-error>
  </mat-form-field>

  <div class="password-rules-container" *ngIf="type === 'ROUTER'">
    <mat-label class="password-rule-item">The password length must be between 8 and 20.</mat-label>
    <mat-label class="password-rule-item">Must contain at least one letter and one digit.</mat-label>
  </div>

</form>

<!--
<ac-form [formSettings]="formSettings"
         [formSchema]="schema"
         *ngIf="formSettings.dialogReady"
         [isEditMode]="false"
         [formModel]="credentials"
         formModelName="credentials"
         [formValidator]="formValidator"
         [auxiliaryModel]="auxiliaryModel"
         [validateAuxiliaryForm]="validateAuxiliaryForm"
         [requiredsAuxiliaryForm]="requiredsAuxiliaryForm">
  <div class="credentials-dialog-container">
    <ac-input-container label="Identifier name">
      <ac-textfield [acModel]="credentials.description"
                    (acChanged)="credentials.description = $event"
                    alternativeName="credentials.description"
                    maxlength="255">
      </ac-textfield>
    </ac-input-container>

    <ac-input-container label="User name">
      <ac-textfield [acModel]="credentials.userName"
                    (acChanged)="credentials.userName = $event"
                    alternativeName="credentials.userName"
                    maxlength="255">
      </ac-textfield>
    </ac-input-container>

    <ac-input-container label="Password">
      <ac-password [acModel]="credentials.password"
                   alternativeName="credentials.password"
                   (acChanged)="credentials.password = $event">
      </ac-password>
    </ac-input-container>

    <ac-input-container label="Confirm password">
      <ac-password [acModel]="auxiliaryModel.passwordConfirm"
                   alternativeName="auxiliaryModel.passwordConfirm"
                   (acChanged)="auxiliaryModel.passwordConfirm = $event">
      </ac-password>
    </ac-input-container>

    <div class="password-rules-container" *ngIf="type === 'ROUTER'">
      <span class="password-rule-item">The password length must be between 8 and 20.</span>
      <span class="password-rule-item">Must contain at least one letter and one digit.</span>
    </div>
  </div>
</ac-form>
-->
